/* eslint-disable consistent-return */
import Vue from 'vue'
import moment from 'moment-timezone'

export function timeFormat(value) {
  if (!value) return
  const date = new Date(value)
  return value && Intl.DateTimeFormat('en', {
    timeStyle: 'medium',
  }).format(new Date(date))
}

export function dateFormat(value) {
  if (!value) return
  const date = Intl.DateTimeFormat().format(new Date(value))
  return date
}

export default function formatDate(value) {
  if (!value) return
  const date = Intl.DateTimeFormat().format(new Date(value))
  const time = timeFormat(value)
  return `${date} ${time}`
}

export function dateTimePickerToUTC(datePickerVal, timePickerVal, userTimeZone) {
  const timeParts = timePickerVal.split(':')
  const momentObj = moment.tz(datePickerVal, userTimeZone)
  momentObj.set({ hour: timeParts[0], minute: timeParts[1] })
  return momentObj
}

export function timeToUTC(time24h, userTimeZone, outputTimeZone) {
  const momentObj = moment.tz(time24h, 'HH:mm', userTimeZone).tz(outputTimeZone)
  return momentObj
}

export function UTCToUserTimeZone(isoDateTimeString, userTimeZone) {
  const momentObj = moment.tz(isoDateTimeString, 'UTC').tz(userTimeZone)
  return momentObj
}

export function userToUTCTimeZone(isoDateTimeString, userTimeZone) {
  const momentObj = moment.tz(isoDateTimeString, userTimeZone).tz('UTC')
  return momentObj
}

export function timeStampToDate(timestamp) {
  if (String(timestamp).length === 13) {
    return `On ${new Date(timestamp).getDate()}-${new Date(timestamp).getMonth() + 1}-${new Date(timestamp).getFullYear()} At ${new Date(timestamp).getHours()}:${new Date(timestamp).getMinutes()}`
  }
  return `On ${new Date(timestamp * 1000).getDate()}-${new Date(timestamp * 1000).getMonth() + 1}-${new Date(timestamp * 1000).getFullYear()} At ${new Date(timestamp * 1000).getHours()}:${new Date(timestamp * 1000).getMinutes()}`
}

export function convertToLocaleAndFormatDate(date) {
  const momentObj = moment.tz(date, 'UTC').tz(moment.tz.guess())
  return `${momentObj.format('DD-MM-YYYY')} ${momentObj.format('HH:mm')}`
}

Vue.filter('formatDate', formatDate)
Vue.filter('timeFormat', timeFormat)
